/**
 * Uplifted from apps/web `utils/validator.js` (32 lines) and apps/mobile `utils/validator.js`
 * (31 lines). Both are plain `.js`, so the `any` parameter types below are the absence of a
 * contract in the source, not a widening of one.
 *
 * FOUR of the five exports are byte-identical in the two apps and live here. The surfaces
 * diverge by exactly one symbol each, and each stays on its own platform:
 * - WEB adds `isPhoneNumber`   — `/^(?:[6-9]\d*)?$/`, a PREFIX test that also accepts "".
 * - MOBILE adds `isValidPhoneNumber` — `/^[6-9]\d{9}$/`, a full ten-digit test.
 *
 * ⚠️ They are NOT the same function under two names — web's accepts a partial number (it is an
 * as-you-type input guard), mobile's only accepts a complete one. Never collapse them.
 *
 * ⚠️ `isValidEmail` here is NOT the `isValidEmail` in either app's `helper/commonHelpers`.
 * This one is `regex.test(...)` and returns a BOOLEAN; that one is
 * `String(email).toLowerCase().match(...)` and returns the match array or `null`. Same name,
 * same regex, different return type — both apps have always carried both, and the audit's
 * check A knows about the pair via PREEXISTING_APP_DUPLICATE.
 */

/**
 * A COMPLETE ten-digit Indian mobile number. Was mobile's variant-only export (web keeps the same
 * body under `utils/regex`, where its importers expect it); shared since 2026-09-16 because the
 * my-orders v2 digital-bill sheet validates through it on both platforms.
 */
export const isValidPhoneNumber = (number: any) => {
  return /^[6-9]\d{9}$/.test(number);
};

/** Byte-identical in both apps. Returns a boolean (see the note above about `commonHelpers`). */
export const isValidEmail = (email: any) => {
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email
  );
};

/**
 * Byte-identical in both apps, INCLUDING its two defects — preserved deliberately:
 * - `typeof number != number` compares a string against the parameter itself, so for any string
 *   input it is true and the function returns `false`;
 * - `a?.length < 4 && a?.length > 8` can never both hold, so the second branch is unreachable
 *   anyway.
 * Fixing either would change what every caller sees. Uplift preserves behaviour, defects included.
 */
export const isValidPin = (number: any) => {
  let a = number?.split('')
   if(typeof number != number){
    return false
   }else if(a?.length<4 && a?.length>8){
    return false
   }else{
    return true
   }
}

/** Byte-identical in both apps. */
export const isNumber = (str: any) => {
  var pattern = /^\d+\.?\d*$/;
  return pattern.test(str);  // returns a boolean
}

/** Byte-identical in both apps. */
export function isDecimalValue(value: any = 0) {
  let regex = /^\d*\.?\d*$/, isValid = false;
  isValid = regex.test(value) ? true : false;
  return isValid;
}
